import { Center, Heading, Img, Text, VStack } from '@chakra-ui/react';
import { PrismicRichText } from '@prismicio/react';

import { Button, Link, PageContainer, PageContent } from 'components';
import { usePageTextContent } from 'context/pageTextContent';
import { Paths, ZmyleLinks } from 'utils/paths';

export const SetupForSaleSection = () => {
  const { content } = usePageTextContent<StoresPageContent>();

  const { title, subtitle, description, registerButton, pictureUrl } =
    content.setupForSale;

  return (
    <PageContainer>
      <PageContent align="center" direction={['column', 'column', 'row']}>
        <VStack
          align="flex-start"
          minW={['unset', 'unset', '70%', '60%']}
          spacing="5rem"
        >
          <VStack align="flex-start" spacing="1rem">
            <Heading fontSize="1.25rem" color="store.primary">
              {title}
            </Heading>

            <Heading fontSize="1.5rem">{subtitle}</Heading>

            <PrismicRichText
              field={description}
              components={{
                hyperlink: ({ text }) => (
                  <Link href={Paths.SEARCH} color="zmyle.primary">
                    {text}
                  </Link>
                ),
                paragraph: ({ children, key }) => (
                  <Text
                    key={key}
                    fontSize="1.125rem"
                    maxW="50rem"
                    style={{ columns: '18.75rem auto' }}
                  >
                    {children}
                  </Text>
                ),
              }}
            />
          </VStack>

          <Link href={ZmyleLinks.SIGN_UP_STORE} isExternal>
            <Button variant="store">{registerButton}</Button>
          </Link>
        </VStack>

        <Center
          h="full"
          w="full"
          maxWidth={['25rem', '25rem', '32rem']}
          mt={['2rem', '2rem', 0]}
          ml={[0, 0, 'auto']}
        >
          <Img src={pictureUrl} w="full" alt="Illustration" loading="lazy" />
        </Center>
      </PageContent>
    </PageContainer>
  );
};
